import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { type, colors, space } from '../theme';
import SectionTitle from '../components/SectionTitle';

const formatDateLong = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })
    + ', '
    + d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
};

// Matches the in-app "Meeting Details" + Participants stack at the top of an
// expanded meeting card.
const InfoField = ({ label, value }) => (
  <View style={{ flex: 1 }}>
    <Text style={[type.micro, { color: colors.muted, textTransform: 'uppercase', letterSpacing: 0.4 }]}>
      {label}
    </Text>
    <Text style={[type.bodyMed, { color: colors.ink, marginTop: 4 }]}>{value || '—'}</Text>
  </View>
);

const MeetingDetailsSection = ({ report }) => {
  const meeting = report.meeting || {};
  const participants = meeting.participants || [];

  return (
    <View wrap={false}>
      <SectionTitle>Meeting Details</SectionTitle>
      <View style={{
        borderTopWidth: 0.6,
        borderBottomWidth: 0.6,
        borderColor: colors.hair,
        paddingVertical: space.md,
      }}>
        <View style={{ flexDirection: 'row', gap: space.lg }}>
          <InfoField label="When" value={formatDateLong(meeting.dateISO)} />
          <InfoField
            label="Duration"
            value={meeting.durationMinutes ? `${meeting.durationMinutes} min` : null}
          />
          {meeting.dealStage && <InfoField label="Deal Stage" value={meeting.dealStage} />}
        </View>

        {participants.length > 0 && (
          <View style={{ marginTop: space.md }}>
            <Text style={[type.micro, { color: colors.muted, textTransform: 'uppercase', letterSpacing: 0.4 }]}>
              Participants
            </Text>
            <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 6, marginTop: 6 }}>
              {participants.map((p, i) => (
                <View
                  key={i}
                  style={{
                    backgroundColor: p.isHost ? colors.tealPale : colors.cardBg,
                    paddingHorizontal: 10,
                    paddingVertical: 4,
                    borderRadius: 12,
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  {p.isHost && (
                    <View style={{
                      width: 5, height: 5, borderRadius: 2.5,
                      backgroundColor: colors.teal, marginRight: 6,
                    }} />
                  )}
                  <Text style={[type.caption, { color: p.isHost ? colors.tealDark : colors.inkSoft }]}>
                    {p.name}
                  </Text>
                </View>
              ))}
            </View>
          </View>
        )}
      </View>
    </View>
  );
};

export default MeetingDetailsSection;
